import { useQuery, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from 'src/constants/queryKeys';
import { ISaveUserData, IUsersUpsertInitial } from 'src/typings/usersManage';
import { useGetAuthData } from 'src/hooks';
import { getInitial, saveUsers } from 'src/api/createUser';
import { useState } from 'react';
import { ApiUrl } from 'src/constants';
import { HttpMethod } from 'src/typings/app';
import { toQueryString } from 'src/helpers/buildQueryParamsString';

export const useUserCreate = (userId: string | undefined) => {
  const { getJWT } = useGetAuthData();
  const [developersIds, setDevelopersIds] = useState<string[]>([]);
  const jwt = getJWT();
  const queryClient = useQueryClient();

  const {
    data: initialData, isLoading: initialDataIsLoading,
  } = useQuery({
    queryKey: [QUERY_KEYS.CREATE_USER_INITIAL, userId],
    queryFn: async (): Promise<IUsersUpsertInitial | null> => {
      if (!jwt) return null;
      const getParams = userId ? toQueryString({
        user: userId,
      }) : '';
      const url = !getParams?.length ? `${ApiUrl.getApiUrl().getUserCreateInitial}` : `${ApiUrl.getApiUrl().getUserCreateInitial}?${getParams}`;
      return (await getInitial(jwt, url)).data;
    },
    enabled: !!jwt,
    cacheTime: 0,
    staleTime: 0,
  });

  const saveUserData = (userData: ISaveUserData, method: HttpMethod) => {
    return saveUsers(jwt, userData, method);
  };

  return {
    initialData,
    initialDataIsLoading,
    developersIds,
    queryClient,
    setDevelopersIds,
    saveUserData,
  };
};
